//Libraries
import React from 'react';
import { connect } from 'react-redux';
//Components
import UserFullName from './utils/UserFullName';
//Actions
// import { getClanMembers } from '../../../actions/clans';
//Material-ui
import Button from '@material-ui/core/Button';
import ArrowUp from '@material-ui/icons/KeyboardArrowUp';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';

class ClanMembers extends React.Component {
  constructor(props){
    super(props);
    this.state = { 
      members: props.value, 
      open: false 
    };
  }
  //Close component on page change
  static getDerivedStateFromProps(props, state){
    const defaultState = {
      members: props.value,
      open: false
    }
    return props.value !== state.members ? defaultState : null;
  }
  handleClick = () => {
    this.setState((prevState) => {
      return {
        members: this.props.value,
        open: !prevState.open
      }
    });
  };

  render() {
    const members = this.props.value;
    return (
      <div>
        <Button onClick={this.handleClick} color="primary">
          {members ? `${members.length == 0 ? '' : members.length} Integrantes` : null}
          {this.state.open ? <ArrowUp  color="secondary"/> : <ArrowDown  color="secondary"/>}
        </Button>
        {
          this.state.open ?
          <div>
            {members.map((element, index) => <UserFullName key={index} userUid={element}/>)}
          </div>
          : null
        }

      </div>
    );
  }
}

export default ClanMembers;
